<app-header
  *ngIf="!(router.url.includes('payment')) && !(router.url.includes('add-co-owner-details')) && !(router.url.includes('invite-co-owner'))"></app-header>
<router-outlet></router-outlet>
<app-footer class="mt-auto"
  *ngIf="!((router.url.includes('payment')) || (router.url.includes('invite-co-owner')) || (router.url.includes('add-co-owner-details')) || (router.url.includes('create-itinerary')) || (router.url.includes('view-itinerary')))"></app-footer>
<app-loader></app-loader>
